// Round to a fixed number of decimal places, e.g. roundTo(74.8427, 1) === 74.8.
export const roundTo = (value: number, decimals = 1): number => {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
};

// Clamp value into the inclusive [min, max] range, e.g. clamp(7, 0, 5) === 5.
export const clamp = (value: number, min: number, max: number): number =>
  Math.max(min, Math.min(value, max));
